export default __webpack_public_path__ + "static/media/add_list.410cfa58.svg";